import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { PrivacyPolicy } from './PrivacyPolicy.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

// The web image's nginx serves index.html for every unknown path (SPA fallback,
// deploy/docker/web-nginx.conf), so the React shell loads at /privacy too — we
// just switch on the pathname. No router needed for two pages.
function pickPage(): React.ReactElement {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/privacy') return <PrivacyPolicy />;
  return <App />;
}

createRoot(rootEl).render(<StrictMode>{pickPage()}</StrictMode>);
